<template>
    <modal :name="modalName" width="100%" height="80%" >
        <div class="d-flex flex-column h-100 p-3">
            <div class="mt-3 text-center">
                <h3 id="modal-headline">
                    {{ $t("Table number") }}
                </h3>
                <div class="mt-2">
                    <p>
                        {{ $t("Please select your table number from the list below.") }}
                    </p>
                </div>
                <div class="px-4">
                    <input type="text" v-model="filters.name" :placeholder="$t('Search for table number')" class="form-control text-center">
                </div>
            </div>
            <div class="flex-fill overflow-auto border mt-4 mx-4">
                <div v-if="filtered_tables.length" class="wrapper p-3" style="font-size: 14px">
                    <div v-for="table in filtered_tables" :key="table.id" class="border text-center p-2 cursor-pointer" :class="{
                        'btn-available-slot': !tableId || tableId !== table.id,
                        'bg-primary text-white': tableId && tableId === table.id
                    }" v-on:click="selectTable(table)">
                        <span>{{ table.name }}</span>
                    </div>
                </div>
                <div v-else class="text-center pt-4">
                    <div class="text-center">{{$t("There are no tables which match the searched criteria")}}</div>
                    <button class="btn btn-reset mt-4" v-on:click="clearFilter()">{{ $t("Try again") }}</button>
                </div>
            </div>
            <div>
                <hr class="mt-4">
            </div>
            <div class="flex justify-content-center border-solid my-2">
                <button class="btn btn-reset mr-2" v-on:click="cancel()">{{ $t("Cancel") }}</button>
                <button class="btn btn-primary ml-2" v-on:click="apply()">{{ $t("Apply") }}</button>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    props: ['value', 'modalName', 'tables'],
    data() {
        return {
            tableId: this.value,
            filters: {
                name: null,
            }
        }
    },
    computed: {
        filtered_tables: function () {
            let tables = this.tables

            if(this.filters.name) {
                tables = this.tables.filter((table) =>_.startsWith(_.toLower(table.name), _.toLower(this.filters.name)));
            }

            return tables;
        }
    },
    methods: {
        selectTable: function(table) {
            this.tableId = table.id;
        },
        cancel: function () {
            this.$modal.hide(this.modalName)
        },
        apply: function() {
            this.$emit('input', this.tableId)
            this.$emit('apply', this.tableId)
        },
        clearFilter: function () {
            this.filters.name = null;
        }
    }
}
</script>

<style scoped>
.wrapper {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    margin: 0 auto;
    column-gap: 10px;
    row-gap: 10px;
}

.wrapper div {
    padding: 10px;
    background: blue;
    color: #fff;
    text-align: center;
}
</style>
